// extracted by mini-css-extract-plugin
export default {"root":"styles_root__3Beh5","selects":"styles_selects__ZDfgM","month":"styles_month__EFVI0","year":"styles_year__m0X71","today":"styles_today__b5TrB","title":"styles_title__B0GDE"};